<template>
    <div>
        <div class="card-header">
            <div class="card-header">
                <div class="d-flex">
                    <div class="flex-fill">
                        <StatementNotificationAssignmentSearch></StatementNotificationAssignmentSearch>
                    </div>

                    <div class="float-end">
                        <StatementNotificationAssignmentPagination></StatementNotificationAssignmentPagination>
                    </div>

                </div>

            </div>

            <div class="card-body">
                <StatementNotificationAssignmentTable></StatementNotificationAssignmentTable>
            </div>
        </div>
    </div>
</template>
<script>
import StatementNotificationAssignmentSearch
    from "@/components/PepStatements/PepStatementMenu/PepStatementNotificationAssignementList/Pep-statement-notification-assignment-search.vue";
import StatementNotificationAssignmentTable
    from "@/components/PepStatements/PepStatementMenu/PepStatementNotificationAssignementList/Pep-statement-notification-assignment-table.vue";
import StatementNotificationAssignmentPagination
    from "@/components/PepStatements/PepStatementMenu/PepStatementNotificationAssignementList/Pep-statement-notification-assignment-pagination.vue";

export default {
    name: 'StatementNotificationAssignmentList',

    components:{
        StatementNotificationAssignmentTable,
        StatementNotificationAssignmentPagination,
        StatementNotificationAssignmentSearch
    }
}
</script>
<style></style>